export default __webpack_public_path__ + "static/media/7.343038c3.svg";